import * as airports from './airports';

export interface DocumentedAirportProps<
  Key extends airports.AirportKey = airports.AirportKey
> {
  name: string;
  btnLabel: string;
  descriptions: string[];
  location: airports.AirportLocationProps<Key>;
}

export const europe: DocumentedAirportProps<'europe'> = {
  name: 'FLIGHTS OF BERLIN',
  btnLabel: 'Berlin Flights',
  descriptions: [
    'This map shows 6 hours of flight data for flights which touched down in Berlin on the 18:th of December 2017, 06:00 to 12:00 GMT.',
    'Berlin receives over 30 million flights yearly and the number is ever rising. It has two open commercial airports, Tegel and Schönefeld; and Tempelhof which closed as recently as 2008. Slated to open in late 2020 is Berlin-Brandenburg Airport, which will become the third busiest airport of Germany',
  ],
  location: airports.europe,
};

export const berlinTop: DocumentedAirportProps<'berlinTop'> = {
  name: 'BERLIN AIRPORTS',
  btnLabel: 'Berlin Airports',
  descriptions: [
    'Schönefeld and the new Berlin-Brandenburg airport are just outside the city, in the south-east.',
    'Tegel airport is situated in the north-west of the city and currently receives twice as many flights as Schönefeld.',
    'The now defunct Tempelhof is close to the heart of the city, just 4km south of Brandenburger Tor',
  ],
  location: airports.berlinTop,
};

export const tempelhof: DocumentedAirportProps<'tempelhof'> = {
  name: 'TEMPELHOF',
  btnLabel: 'Tempelhof Airport',
  descriptions: [
    "Berlin Tempelhof Airport (THF) was one of Europe's three iconic pre-World War II airports. It opened in 1923 and closed in 2008. It acquired a further iconic status as the centre of the Berlin Airlift of 1948-49",
    'It is now one of the biggest city parks of Berlin known as Tempelhofer Field. Today, the area has a six-kilometre cycling, skating and jogging trail, a 2.5-hectare BBQ area, a dog-walking field covering around four hectares and an enormous picnic area for all visitors',
  ],
  location: airports.tempelhof,
};

export const tegel: DocumentedAirportProps<'tegel'> = {
  name: 'TEGEL',
  btnLabel: 'Tegel Airport',
  descriptions: [
    'Berlin Tegel Airport (TXL), is the current main airport of Berlin, built during the Berlin Airlift in 1948 and scheduled to close when Berlin Brandenburg Airport opens.',
    'The airport is the fourth busiest airport in Germany with over 21 million passengers in 2016. On 1 September 1975, Tegel replaced Tempelhof as the main airport of West Berlin.',
  ],
  location: airports.tegel,
};

export const schoenefeld: DocumentedAirportProps<'schoenefeld'> = {
  name: 'SCHÖNEFELD',
  btnLabel: 'Schönefeld Airport',
  descriptions: [
    'Berlin Schönefeld Airport (SXF), founded in 1934, was the airport for East Berlin during the Cold War. It was originally built to serve Henschel aircraft plant in Schönefeld.',
    'In 1947, the Soviet Military Administration in Germany approved the construction of a civilian airport at the site. Schönefeld served over 11 million flights in 2016.',
  ],
  location: airports.schoenefeld,
};

export const berlinBradenburg: DocumentedAirportProps<'berlinBradenburg'> = {
  name: 'BERLIN-BRANDENBURG',
  btnLabel: 'Berlin-Brandenburg Airport',
  descriptions: [
    'Berlin Brandenburg Airport (BER) is a new airport currently under construction adjacent to Schönefeld Airport, which is to become the single airport serving the city.',
    'With a projected annual passenger number of around 34 million it would become the third busiest airport in Germany',
    'Construction began in 2006 and it was originally planned to open in October 2011, but the airport has encountered a series of serious delays and cost overruns. Autumn 2020 is currently the new official opening date.',
  ],
  location: airports.berlinBradenburg,
};
